







































































































import {Component, Vue} from "vue-property-decorator";
import AppFooter from "../../layout/AppFooter.vue";
import Menu from "../../layout/Menu.vue";

@Component({
    components: {
        AppFooter,
        Menu,
    }
})

export default class UserLayout extends Vue {
    color : String = 'blue';
    mode:String = '';
    snackbar:Boolean = false;
    text: string =  'Ana Sayfaya gitmek istiyor musunuz?';
    timeout: number = 3000;
    x: string | null = null;
    y: string | null = 'top';
    drawer: any = null;
    setTheme(){
        localStorage.setItem("themeDark", this.$vuetify.theme.dark.toString());
    }
    created(){
        this.$vuetify.theme.dark = localStorage.getItem("themeDark") == "true";
    }
    toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.setTheme();
    }
};
